module.exports = __webpack_public_path__ + "static/media/bali-bombings-feature-banner-sm@1x.f407ae4f.webp";